import {Action, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {EntityModule} from './entityModule';
import {ServiceData} from '@/services/interfaces';
import {ServiceName} from '@/services/enums';

/*
    Динамический модуль хранилища vuex для получения сервисов
*/

const moduleName = 'serviceModule';

function transformGet(elem: any): ServiceData {
  return {
    name: elem.name as ServiceName,
    description: elem.description,
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class ServiceModule extends EntityModule {
  protected routeName = 'service-types';

  get all(): ServiceData[] {
    return super.all as ServiceData[];
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return await super.fetchAll(transformGet);
  }
}

export default getModule(ServiceModule);
